import AppHeader from '../components/ui/AppHeader';
import MailingListForm from '../components/mailinglist/MailingListForm';

export default function MailingListPage() {
  return (
    <>
      <AppHeader />
      <main className="sdx ml-page">
        <div
          className="ml-backdrop"
          aria-hidden="true"
          style={{ backgroundImage: "url('/images/Garage_2.png')" }}
        />
        <MailingListForm />
      </main>
      <sdx-footer></sdx-footer>
    </>
  );
}
